module.exports = __webpack_public_path__ + "static/media/logo-inverse.e19d24a4.svg";